module.exports = __webpack_public_path__ + "8304757a94a90f4eb7c3fb4e5e4c18e5.fbx";